import { lazy } from 'react';

// vite模式使用import语法。因为cli不支持import语法分包。

// 首页
export const Home = lazy(() => import('../nodes/home'));

// 社招首页
export const Social = lazy(() => import('../nodes/social'));

// 校招首页
export const Campus = lazy(() => import('../nodes/campus'));

// 登录页
export const Login = lazy(() => import('../nodes/login'));

// 职位列表
export const PositionList = lazy(() => import('../nodes/position/list'));

// 职位详情
export const PositionDetail = lazy(() => import('../nodes/position/detail'));

// 投递成功
export const DeliverySuccess = lazy(() => import('../nodes/deliverySuccess'));

// 个人中心/我的简历
export const ResumeDetail = lazy(() => import('../nodes/personalCenter/resumeDetail'));

// 个人中心/账号设置
export const AccountSetting = lazy(() => import('../nodes/personalCenter/accountSetting'));

// 个人中心/投递记录
export const DeliveryRecord = lazy(() => import('../nodes/personalCenter/deliveryRecord'));

// 投递确认页
export const Deliveryconfirm = lazy(() => import('../nodes/deliveryConfirm'));

// 校招tv页
export const CampusTV = lazy(() => import('../nodes/campusTV'));

// 常见问题页
export const Question = lazy(() => import('../nodes/question'));

// 了解美团页
export const About = lazy(() => import('../nodes/about'));

// 北斗页
export const Beidou = lazy(() => import('../nodes/beidou'));

// 启航页
export const QiHang = lazy(() => import('../nodes/qihang'));

// 校招行程
export const CampusSchedule = lazy(() => import('../nodes/campusSchedule'));

// 职位分享落地页
export const SharePosition = lazy(() => import('../nodes/position/share'));

// 北斗新主页
export const BeiDouProgram = lazy(() => import('../nodes/beidouprogram'));
